import React from 'react';
import { Mail, Phone } from 'lucide-react';
import Reveal from './Reveal';
import { teamMedia } from '../mock';
import { useI18n } from '../i18n/I18nContext';

export default function Team() {
  const { t } = useI18n();
  const members = t('team.members') || [];
  return (
    <section className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5">
        <div className="mb-14 max-w-3xl">
          <div className="text-[11px] tracking-[0.22em] uppercase text-blue-600 mb-4">{t('team.section_label')}</div>
          <h3 className="font-display text-3xl md:text-4xl lg:text-5xl font-semibold text-slate-900 leading-tight">
            {t('team.title_a')} <span className="text-gradient-green">{t('team.title_b')}</span>
          </h3>
        </div>
        <div className="grid gap-6 md:grid-cols-2">
          {members.map((m, i) => {
            const media = teamMedia[i] || {};
            return (
              <Reveal key={m.name} delay={i * 80}>
                <div className="group relative rounded-3xl border border-blue-500/12 bg-white overflow-hidden hover:border-blue-500/30 transition-all card-lift">
                  <div className="grid md:grid-cols-5 h-full">
                    <div className="md:col-span-2 relative min-h-[300px] overflow-hidden">
                      <img src={media.img} alt={m.name} className="h-full w-full object-cover object-top grayscale-[30%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" />
                      <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent" />
                      <div className="absolute inset-0 bg-gradient-to-r from-transparent to-white/50" />
                      <div className="absolute top-4 left-4 font-mono text-xs tracking-widest text-blue-600">{String(i + 1).padStart(2, '0')}</div>
                    </div>
                    <div className="md:col-span-3 p-7 space-y-4 flex flex-col">
                      <div className="text-[11px] tracking-[0.2em] uppercase text-blue-600">{m.role}</div>
                      <h4 className="font-display text-2xl md:text-3xl font-semibold text-slate-900">{m.name}</h4>
                      <p className="text-sm text-slate-700 leading-relaxed flex-1">{m.bio}</p>
                      <div className="flex items-center gap-2 pt-2">
                        {(media.langs || '').split(' · ').map((l) => l && (
                          <span key={l} className="rounded-md border border-blue-500/20 px-2 py-0.5 text-[10px] tracking-widest text-blue-600">{l}</span>
                        ))}
                      </div>
                      <div className="pt-3 flex flex-col gap-2 text-sm text-slate-700">
                        <a href={`mailto:${media.email}`} className="inline-flex items-center gap-2 hover:text-blue-600 transition-colors"><Mail className="h-4 w-4 text-blue-500" />{media.email}</a>
                        <a href={`tel:${(media.phone || '').replace(/\s/g, '')}`} className="inline-flex items-center gap-2 hover:text-blue-600 transition-colors"><Phone className="h-4 w-4 text-blue-500" />{media.phone}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
